import { createContext } from "react";

import { AlertType } from "./AlertType";
import { AlertVariant } from "./AlertVariant";

/**
 * The alert data
 */
export interface AlertData {
  /**
   * The alert id.
   */
  readonly id?: string;

  /**
   * The alert message
   */
  readonly message: string | Error;

  /**
   * The type of the alert.
   */
  readonly type: AlertType;

  /**
   * The variant of the alert.
   */
  readonly variant?: AlertVariant;

  /**
   * The style of the alert.
   * @deprecated Use variant instead.
   */
  readonly style?: AlertVariant;

  /**
   * The timeout of the alert in ms: defaults to 5000.
   */
  readonly timeout?: number;
}

/**
 * The alert showing function.
 */
export interface ShowAlert {
  /**
   * Shows an alert
   */
  (alert: AlertData): void;
}

/**
 * The alert hiding function.
 */
export interface HideAlert {
  /**
   * Hides the current alert.
   */
  (): void;
}

/**
 * The alert context data.
 */
export interface AlertContextData {
  /** Indicates whether this is the default instance or not. */
  readonly default: boolean;

  /**
   * Shows an additional alert.
   */
  readonly showAlert: ShowAlert;

  /**
   * Hides a specific alert.
   */
  readonly hideAlert: HideAlert;
}

/**
 * A no-operation function.
 */
const NoOp = (): void => {
  /** No operation */
};

/**
 * The alert context.
 */
export const AlertContext = createContext<AlertContextData>({
  default: true,
  showAlert: NoOp,
  hideAlert: NoOp,
});
